<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Devolución a proveedor</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-12">
              <br />
              <div class="form-inline justify-content-sm-end">
                <div>
                  <TiendaSelectComponent
                    titulo=""
                    style="display: block; width: 300px"
                    :current="current"
                  />
                </div>
                <div>
                  <ProveedoresSelectComponent
                    titulo=""
                    style="display: block; width: 300px"
                    :current="current"
                  />
                </div>
                &nbsp; &nbsp;
                <div>
                  <UsuariosSelectComponent
                    titulo=""
                    style="display: block; width: 250px"
                    :current="current"
                  />
                </div>
                &nbsp; &nbsp;
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  style="display: block; width: 100px"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="refreshData()"
                />
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Número"
                  style="display: block; width: 100px"
                  v-model="numero"
                  type="text"
                  v-on:keyup.enter="refreshData()"
                />

                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  style="display: block; width: 100px"
                  @change="refreshData()"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="refreshData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-sm btn-primary btn-block"
          data-toggle="modal"
          data-target="#exampleModal"
        >
          Nueva Devolución
        </button>
        <br />
        <devolucionProveedorTableComponent :dataTabla="dataTabla" />
        <PaginationComponent
          :currentPage="currentPage"
          tipo="MINI"
          :data="dataTabla"
          @pagechanged="refreshData"
        />
      </div>
      <devolucionProveedorModalComponent />
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import devolucionProveedorTableComponent from "@/components/wms/devolucion_proveedor/devolucionProveedorTableComponent";
import devolucionProveedorModalComponent from "@/components/wms/devolucion_proveedor/devolucionProveedorModalComponent";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
  components: {
    ProveedoresSelectComponent,
    UsuariosSelectComponent,
    TiendaSelectComponent,
    devolucionProveedorTableComponent,
    UsuarioEnTablaComponent,
    devolucionProveedorModalComponent,
    PaginationComponent,
  },
  data() {
    return {
      current: {
        proveedor: "",
        usuario: "",
        tienda: "",
      },
      numero: "",
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      dataTabla: {},
    };
  },
  mounted() {
    let self = this;
    self.refreshData();
  },
  methods: {
    refreshData(page) {
      let self = this;
      if (page) {
        this.currentPage = page;
      }
      let params = {
        "filter[search]": this.searchtext,
        estado: this.filtro_estado,
        numero: this.numero,
        proveedor: this.current.proveedor.codigo,
        usuario: this.current.usuario.id,
        tienda: this.current.tienda,
        page: this.currentPage,
      };
      DynamicService.fetch("inv", "devolucion_proveedor", params).then(
        (res) => {
          self.dataTabla = res.data;
        }
      );
    },
    clearFilterData() {
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      this.filtro_estado = "";
      this.current.proveedor = "";
      this.numero = "";
      this.current.usuario = "";
      this.current.tienda = "";
      this.refreshData();
    },
  },
};
</script>
